/**
 * Sustituye en HTML las marcas `{{DOCUMENTACION:slug}}` por el texto guardado en el CRM.
 * Los slugs solo pueden contener letras minúsculas, números y guiones.
 *
 * @param {string} html
 * @returns {Promise<string>}
 */
export async function sustituirPlaceholdersDocumentacion(html) {
  if (!html || typeof html !== "string") return html;
  const re = /\{\{DOCUMENTACION:([a-z0-9-]+)\}\}/gi;
  const seen = new Map();
  let m;
  while ((m = re.exec(html)) !== null) {
    const raw = m[1];
    if (!raw) continue;
    const slug = raw.toLowerCase();
    if (!seen.has(slug)) seen.set(slug, null);
  }
  if (seen.size === 0) return html;

  const BASE =
    window.location.hostname === "localhost"
      ? "http://localhost:4000/api"
      : `${window.location.origin}/api`;
  const token = localStorage.getItem("token");
  const headers = {};
  if (token) headers.Authorization = `Bearer ${token}`;

  for (const slug of seen.keys()) {
    try {
      const r = await fetch(`${BASE}/documentacion/fragmento/${encodeURIComponent(slug)}`, {
        headers,
      });
      const j = await r.json();
      const text = j && j.ok && j.contenido != null ? String(j.contenido) : "";
      seen.set(slug, text);
    } catch {
      seen.set(slug, "");
    }
  }

  return html.replace(/\{\{DOCUMENTACION:([a-z0-9-]+)\}\}/gi, (_, g1) => {
    const slug = String(g1 || "").toLowerCase();
    return seen.has(slug) ? seen.get(slug) : "";
  });
}
